export function CollapseSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/collapse.svg'"></ng-include>`
    }
}